export const DATATYPES = {
  NUMBER: 'NUMBER',
  STRING: 'STRING'
};

export const AUTOCOMPLETE_MAX_RESULTS = 10;
